import React, { useEffect, useRef, useState } from "react";
import {
    Table,
    Button,
    Modal,
    Form,
    Input,
    DatePicker,
    message,Popconfirm
} from "antd";
import dayjs from "dayjs";
import JoditEditor from "jodit-react";
import firebase from "../../../firebase";
import {MDBSpinner} from "mdbreact";

const SupportUpdateAdmin = (props) => {
    const [form] = Form.useForm();
    const editor = useRef(null);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    // Big data pagination (SERVER SIDE)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 20,
        total: 0,
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);

    // -----------------------
    // LOAD LIST (BIG DATA)
    // -----------------------
    const loadList = async () => {
        setLoading(true);
        try {
            let first;
           first = await props.db.collection('supportUpdate')
                .where('delete', '==', false)
                .orderBy("publishDate","desc");
            first.get()
                .then((snapshot) => {
                    if(snapshot.docs.length > 0) {
                        let supports = [];
                        snapshot.forEach((doc) => {
                            let data = doc.data();
                            data.id = doc.id;
                            supports.push(data)
                        })
                        setData(supports);
                        // setPagination({
                        //     current: page,
                        //     pageSize,
                        //     total: supports.length,
                        // });
                    }
                })

        } catch (err) {
            message.error("Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadList();
    }, [reload]);

    // -----------------------
    // TABLE COLUMNS
    // -----------------------
    function n(n){
        return n > 9 ? "" + n: "0" + n;
    }
    const handleDelete = key => {
        let supportUpdateRef = props.db.collection('supportUpdate').doc(key);
        let setWithMerge = supportUpdateRef.update({
            updatedUser: props.user.id,
            updatedUserName: props.user.last_name + props.user.first_name,
            delete: true,
            updated: firebase.firestore.Timestamp.fromDate(new Date()),
        }).then((snapshot) => { setReload(!reload);});
        message.success("Deleted successfully");
    };
    const columns = [
        // {
        //     id: "ID",
        //     dataIndex: "id",
        //     width: 100,visible: false
        // },
        {
            title: "タイトル",
            dataIndex: "title",
            width: 250,
        },
        {
            title: "公開日",
            dataIndex: "publishDate",
            width: 160,
            render: (val) => val.toDate().getFullYear() + '/'
                + n(val.toDate().getMonth()+1) + '/'
                + n(val.toDate().getDate()),
        },
        {
            title: "本文",
            dataIndex: "htmlContent",
            ellipsis: true,
            render: (html) => (
                <div
                    style={{ maxWidth: 300, maxHeight: 60, overflow: "hidden" }}
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            ),
        },
        {
            title: "",
            width: 160,
            render: (_, record) => (
                <>
                    <Popconfirm title="本当に削除しますか?" onConfirm={() => handleDelete(record.id)}>
                        <Button type="link">
                            消去
                        </Button>
                    </Popconfirm>
                    <Button type="link" onClick={() => openEdit(record)}>
                        編集
                    </Button>
                </>
            ),
        },
    ];

    // -----------------------
    // OPEN CREATE
    // -----------------------
    const openCreate = () => {
        setEditingRecord(null);
        form.resetFields();
        setModalOpen(true);
    };

    // -----------------------
    // OPEN EDIT
    // -----------------------
    const openEdit = (record) => {
        setEditingRecord(record);
        form.setFieldsValue({
            id: record.id,
            title: record.title,
            publishDate:  dayjs(record.publishDate.toDate()),
            htmlContent: record.htmlContent,
        });
        setModalOpen(true);
    };

    // -----------------------
    // SAVE (CREATE / UPDATE)
    // -----------------------
    const onSave = async () => {
        try {
            const values = await form.validateFields();
            console.log('payload1', values);
            const payload = {
                ...values,
                publishDate: firebase.firestore.Timestamp.fromDate(new Date(values.publishDate)) //values.publishDate.format("YYYY-MM-DD"),
            };
            console.log('payload', payload);
            console.log('editingRecord', editingRecord);

            if (editingRecord) {
                //UPDATE
                let supportUpdateRef = props.db.collection('supportUpdate').doc(editingRecord.id);
                let setWithMerge = supportUpdateRef.update({
                    title: payload.title,
                    publishDate: payload.publishDate,
                    htmlContent: payload.htmlContent,
                    updatedUser: props.user.id,
                    updatedUserName: props.user.last_name + props.user.first_name,
                    delete: false,
                    updated: firebase.firestore.Timestamp.fromDate(new Date()),
                }).then((snapshot) => { setReload(!reload);});
                message.success("Updated successfully");
                // loadList(pagination.current, pagination.pageSize);
            } else {
                // CREATE
                let supportUpdateRef = props.db.collection('supportUpdate').doc();
                let setWithMerge = supportUpdateRef.set({
                    title: payload.title,
                    publishDate: payload.publishDate,
                    htmlContent: payload.htmlContent,
                    createdUser: props.user.id,
                    createdUserName: props.user.last_name + props.user.first_name,
                    delete: false,
                    created: firebase.firestore.Timestamp.fromDate(new Date()),
                }, { merge: true }).then((snapshot) => { setReload(!reload);});
                message.success("Created successfully");
                setReload(!reload);
            }
            setModalOpen(false);

        } catch (err) {
            console.error(err);
            message.error("Save failed");
        }
    };

    // -----------------------
    // JODIT CONFIG
    // -----------------------
    const joditConfig = {
        autofocus: false,
        readonly: false,
        toolbar: true,
        spellcheck: true,
        language: "ja",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: true,
        showWordsCounter: true,
        showXPathInStatusbar: false,
        askBeforePasteHTML: true,
        askBeforePasteFromWord: true,
        //defaultActionOnPaste: "insert_clear_html",
        //buttons: buttons,
        uploader: {
            insertImageAsBase64URI: true
        },
        width: "100%",
        height: "600",
        cleanHTML: {
            fillEmptyParagraph: false,
            removeEmptyElements: false,
            replaceOldTags: false,
            cleanOnPaste: false
        },
    };

    return (
        <>
            {props.user && props.user.admin &&  <>
                <Button type="primary" onClick={openCreate} style={{ marginBottom: 16 }}>
                    + 更新情報を作成する
                </Button>

                <Table
                    rowKey="id"
                    loading={loading}
                    dataSource={data}
                    columns={columns} pagination={{showSizeChanger: true,total: data.length}}
                    // pagination={{
                    //     current: pagination.current,
                    //     pageSize: pagination.pageSize,
                    //     total: pagination.total,
                    //     showSizeChanger: true,
                    // }}
                    // onChange={(pag) =>
                    //     loadList(pag.current, pag.pageSize)
                    // }
                    scroll={{ y: 700, x: 'max-content' }}
                />
                {loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner/></div>}
                {/* CREATE / EDIT MODAL */}
                <Modal
                    title={editingRecord ? "更新情報を編集する" : "更新情報を作成する"}
                    open={modalOpen}
                    onOk={onSave} okText={'保 存'} cancelText={'キャンセル'}
                    onCancel={() => setModalOpen(false)}
                    width={900}
                    destroyOnClose
                >
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name="title"
                            label="タイトル"
                            rules={[{ required: true, message: "Title is required" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="publishDate"
                            label="公開日"
                            rules={[{ required: true, message: "Publish date is required" }]}
                        >
                            <DatePicker style={{ width: "100%" }} />
                        </Form.Item>

                        {/* JODIT HTML EDITOR */}
                        <Form.Item
                            name="htmlContent"
                            label="本文"
                            rules={[{ required: true, message: "Content is required" }]}
                        >
                            <JoditEditor
                                ref={editor}
                                config={joditConfig}
                                onBlur={(newContent) => {
                                    form.setFieldsValue({ htmlContent: newContent });
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Modal></>}

        </>
    );
};

export default SupportUpdateAdmin;
